const accountTypes = {
    owner: "OWNER",
    store: "STORE"
}

export default accountTypes;